import { TOEFL_PROGRAM_ID } from "../constants/Constants";
import { ReactComponent as IDVLogo } from "../idv-logo.svg";
import LandingLogo from "../landing_logo.png";
import Header from "./Header";

const LandingScreen = ({ onContinue }) => {
  // const getClassNameByProgram = () => {
  //   if (programId.toUpperCase() == "TEL") {
  //     return "toefl-landing-page-bg";
  //   }
  //   if (programId.toUpperCase() == "GRE") {
  //     return "gre-landing-page-bg";
  //   }
  // };

  const programId = sessionStorage.getItem("program_id");

  return (
    <div
      className={`${
        programId == TOEFL_PROGRAM_ID
          ? "toefl-landing-page-bg"
          : "gre-landing-page-bg"
      } landing-screen-container`}
    >
      <Header />
      <div className={`document-selection-screen`}>
        <div className="document-options">
          <div className="document-option">
            <img
              src={LandingLogo}
              className="landing-logo"
              alt="Landing Logo"
            />
          </div>
          <div>
            <h1>Identify Verification</h1>
            <span>Use this page to verify your identity</span>
          </div>
        </div>

        <div className="action-container">
          <button
            className={`continue-button ${
              programId == TOEFL_PROGRAM_ID
                ? "toefl-button-bg"
                : "gre-button-bg"
            }`}
            onClick={onContinue}
          >
            CONTINUE
          </button>
        </div>
      </div>
    </div>
  );
};

export default LandingScreen;
